import type { Competitor } from '../types'

// Sources (checked 2026-10-01): guns.lol/pricing (EUR, one-time), help.guns.lol
// (getting started, customization, assets, audio, Discord, templates, analytics,
// premium guides, changelog), guns.lol/terms. WebFetch loops on guns.lol, so
// pages and the dashboard bundle were read with curl.
const gunslol: Competitor = {
  slug: 'gunslol',
  aliases: ['guns', 'guns-lol'],
  name: 'guns.lol',
  tagline: 'Popular free biolink with effects, music, and a one-time Premium tier.',
  site: 'https://guns.lol',
  pricingUrl: 'https://guns.lol/pricing',
  checkedOn: '2026-10-01',
  seo: {
    title: 'guns.lol alternative: mychar.gg vs guns.lol compared (2026)',
    description: 'A guns.lol alternative with a live on-page editor, video clips, Twitch and YouTube sections, comments, and custom domains. Features and one-time prices compared.'
  },
  hero: {
    title: 'The guns.lol alternative with a live editor',
    description: 'Keep the animated, music-on look and get more to build with: edit the page itself, add clips that play in place, connect Twitch and YouTube, and use your own domain.'
  },
  summary: 'mychar.gg and guns.lol are both one-time-payment biolinks with effects and music, so the difference is in what you build with. mychar.gg adds a live editor on the page itself, video clips that play in place, Twitch and YouTube sections, visitor comments, and custom domains, and Pro costs €6.99 once against €7.99 for guns.lol Premium. guns.lol gives more features away on its free plan, such as video backgrounds, basic effects, and detailed analytics, while mychar.gg Free gives you the live editor on the page itself.',
  chooseMychar: [
    'want to edit the page itself and see every change live',
    'want video clips, Twitch live status, and your latest YouTube uploads on the page',
    'want visitor comments and your own domain',
    'want the full set of 13 effects and 10 cursor trails'
  ],
  chooseThem: [
    'want the most features for free, including video backgrounds and analytics',
    'want custom font uploads on the first paid tier',
    'use its image host, or want Spotify and Last.fm widgets'
  ],
  features: {
    free_plan: { yes: true, text: 'Music, video backgrounds, basic effects' },
    paid_plans: 'Premium €7.99, plus one-time extras',
    billing: 'Once',
    first_year: '€7.99 in total (Premium)',
    custom_domain: { yes: false, text: 'Not for profiles' },
    editor: 'Settings forms that you save',
    drag_drop: { yes: true, text: 'Reorder links' },
    themes: { yes: true, text: 'Community templates' },
    layouts: 'Several on Premium, 1 on Free',
    fonts: '13 on Premium',
    custom_fonts: { yes: true, text: 'Premium' },
    effects: { yes: true, text: '6 on Free, 8 on Premium' },
    cursors: { yes: true, text: 'Upload free, effects on Premium' },
    video_background: { yes: true, text: 'Free, up to 100 MB' },
    custom_code: false,
    music_player: { yes: true, text: 'Free' },
    video_clips: { yes: false, text: 'Background video only' },
    comments: false,
    view_counter: { yes: true, text: 'Hiding it needs Premium' },
    badges: { yes: true, text: 'Many, custom badge €8.99' },
    youtube: 'Channel widget on Premium',
    twitch: { yes: false, text: 'Link only' },
    discord: { yes: true, text: 'Presence free, server widget on Premium' },
    music_embeds: { yes: true, text: 'Spotify and Last.fm widgets, Premium' },
    analytics_free: { yes: true, text: 'Views, clicks, countries, referrers' },
    analytics_live: { yes: true, text: 'Countries and referrers, free' },
    store: false,
    email_capture: false,
    mobile_app: false
  },
  plans: [
    { name: 'Free', price: '€0', period: 'forever', note: 'Music, video backgrounds, basic effects, Discord presence, and analytics.' },
    { name: 'Premium', price: '€7.99', period: 'one-time', note: 'Layouts, fonts and font uploads, cursor effects, widgets, and SEO settings.' },
    { name: 'Custom Badge', price: '€8.99', period: 'one-time', note: 'Your own badge icon and name.' },
    { name: 'Image Host', price: '€4.99', period: 'one-time', note: 'Image hosting with custom domains for image links, plus a gallery.' },
    { name: 'Verified', price: '€14.99', period: 'one-time', note: 'Verified badge and Discord role.' }
  ],
  plansNote: 'EUR. All guns.lol purchases are lifetime and, per its terms, final.',
  advantages: [
    {
      title: 'Edit the page itself, live',
      description: 'Change your name and bio where they appear, drag things into place, and watch effects and fonts update as you pick them, instead of saving settings and checking the result.',
      icon: 'i-lucide-mouse-pointer-click'
    },
    {
      title: 'Video clips that play on the page',
      description: 'Upload up to 18 clips that visitors watch in place. On guns.lol, video works as a background only.',
      icon: 'i-lucide-clapperboard'
    },
    {
      title: 'Twitch and YouTube that update themselves',
      description: 'Show your Twitch live status, schedule, and clips, and your latest YouTube uploads. guns.lol links to Twitch only.',
      icon: 'i-lucide-radio'
    },
    {
      title: 'Your own domain',
      description: 'Put your page on a domain you own for €2.99 per month, on any plan. guns.lol profiles stay on guns.lol.',
      icon: 'i-lucide-globe'
    },
    {
      title: 'Comments from visitors',
      description: 'Let people leave a message on your page and moderate it from your dashboard. guns.lol has no comment section.',
      icon: 'i-lucide-message-circle'
    },
    {
      title: 'More effects for less',
      description: 'Pro is €6.99 once, a euro less than guns.lol Premium, and Elite (€12.99) includes 13 background effects and 10 cursor trails.',
      icon: 'i-lucide-sparkles'
    }
  ],
  strengths: [
    {
      title: 'A bigger free plan',
      description: 'Video backgrounds, a music player, six background effects, cursor uploads, and analytics with countries and referrers are all free on guns.lol, though you set them up in settings forms. On mychar.gg, effects, video backgrounds, and the analytics breakdowns need Pro, while the live on-page editor is free.'
    },
    {
      title: 'Font uploads on the first paid tier',
      description: 'guns.lol Premium (€7.99) includes custom font uploads. On mychar.gg, font uploads are part of Elite.'
    },
    {
      title: 'A large community',
      description: 'With more than two million users and a big template gallery, there are plenty of ready-made looks to start from.'
    },
    {
      title: 'Extras beyond the profile',
      description: 'One-time add-ons cover an image host, custom badges, and a verified badge, and Premium adds Spotify and Last.fm widgets.'
    }
  ],
  sections: [
    {
      title: 'Why people look for a guns.lol alternative',
      paragraphs: [
        'guns.lol is popular for good reasons: it is free to start, the effects and music look good with little effort, and Premium is a single €7.99 payment. People who move usually want to build more than a profile card. They want clips that play on the page instead of only a background video, a Twitch section that shows when they are live, a place for visitors to leave a message, or the page on their own domain, which guns.lol only offers for its image host.',
        'The other reason is the editing itself. guns.lol is set up through dashboard settings that you save and then check on the page. Some people prefer to work on the page directly and see every change the moment they make it.'
      ]
    },
    {
      title: 'How mychar.gg is different',
      paragraphs: [
        'On mychar.gg the [editor](/docs/customization) is your page in edit mode. You edit your name and bio in place, drag widgets like the music player to a corner, and pick layouts, fonts, colors, backgrounds, effects, and cursor trails from a sidebar while the page updates live. Community [skins](/skins) give you a complete look in one click that you can then change.',
        'Beyond the look, the page holds more. Video clips play in place, YouTube and Twitch sections keep themselves current, visitors can comment, and friends, achievements, a game library, and a setup section are ready to add. The music player is on every plan, and so are analytics for views, clicks, and top links. Our [guns.lol alternatives post](/blog/guns-lol-alternatives-2026) compares a few more options, and the [guide for gamers](/for/gamers) covers the gaming sections in detail.'
      ]
    }
  ],
  switchSteps: [
    { title: 'Claim your username', description: 'Sign up free at [mychar.gg/signup](/signup). If your guns.lol name is free here too, take it so your audience recognizes it.' },
    { title: 'Bring your assets', description: 'Upload the same avatar, background, cursor, and music track you use on guns.lol. Video backgrounds and cursor uploads start on Pro.' },
    { title: 'Rebuild the look', description: 'Pick a layout and font, set your colors, and choose an effect like rain, snow, or sakura, or start from a community skin and adjust it.' },
    { title: 'Add what was missing', description: 'Upload clips, connect Twitch and YouTube, turn on comments, and show your Discord profile. The [Twitch guide](/docs/integrations/twitch) covers the live section.' },
    { title: 'Swap the link', description: 'Replace your guns.lol link in your bios, Discord profile, and stream panels, or point your own domain at your page with the [custom domain add-on](/docs/profile/custom-domain).' }
  ],
  faq: [
    {
      label: 'Is mychar.gg cheaper than guns.lol?',
      content: 'Slightly. Both are one-time payments: mychar.gg Pro is €6.99 and Elite €12.99, while guns.lol Premium is €7.99. guns.lol gives more away on its free plan, so compare what you need before you pay.'
    },
    {
      label: 'Does mychar.gg have background effects like guns.lol?',
      content: 'Yes. Pro includes 7 effects (rain, snow, particles, stars, fire, fireflies, smoke) and Elite has 13, adding matrix, glitch, sparks, sakura, plasma, and lasers. Effects are not on the Free plan.'
    },
    {
      label: 'Can I keep my music and video background?',
      content: 'Yes. The music player is on every plan, with 1 track on Free, 3 on Pro, and 6 on Elite. Video backgrounds are on Pro and Elite. See the [backgrounds guide](/docs/customization/backgrounds).'
    },
    {
      label: 'Can I use my own domain?',
      content: 'Yes. The custom domain add-on is €2.99 per month on any plan and keeps your mychar.gg/yourname link working. guns.lol does not offer custom domains for profiles.'
    },
    {
      label: 'Does mychar.gg show my Discord?',
      content: 'Yes. Connect Discord to show your Discord profile card on every plan. On Elite, a Discord invite link can show as a live server card with the member count and a join button. See the [Discord guide](/docs/integrations/discord).'
    }
  ]
}

export default gunslol
